module.exports = __webpack_public_path__ + "images/logo-4f1b65.png";